import type { SkillListStateFilter } from '@kirin/api-client/contracts/skills';
import { SKILL_PLUGIN_SOURCE_PREFIX } from '@kirin/api-client/contracts/policy-exceptions';

/**
 * `plugin:code-review` reads as "code-review" under a Plugin label; project
 * and user stand alone. Keeps a long plugin id out of the column.
 *
 * Lives here rather than beside the cells so that module can stay
 * components-only — mixing the two costs Fast Refresh
 * (react-refresh/only-export-components).
 */
export function sourceLabel(source: string): string {
  if (source.startsWith(SKILL_PLUGIN_SOURCE_PREFIX)) {
    return `Plugin: ${source.slice(SKILL_PLUGIN_SOURCE_PREFIX.length)}`;
  }
  return source === 'user' ? 'User' : 'Project';
}

/**
 * Inventory → Skills (KIR-4699). The table id namespaces the DataTable's
 * persisted column/sort state, so it must be unique across tabs.
 */
export const SKILLS_TABLE_CONFIG = {
  tableId: 'org-inv-skills',
} as const;

/**
 * The pill row above the table. "Marked for delete" rather than "Blocked":
 * enforcement quarantines the skill file, and the copy should say so.
 */
export const SKILL_LIST_STATE_OPTIONS: ReadonlyArray<{
  value: SkillListStateFilter;
  label: string;
}> = [
  { value: 'all', label: 'All' },
  { value: 'allowed', label: 'Allowed' },
  { value: 'marked_for_delete', label: 'Marked for delete' },
];

/**
 * URL keys for persisted column filters.
 *
 * Short and prefixed `s` so they stay readable in a shared link and cannot
 * collide with another tab's keys in the same query string.
 */
export const SKILL_FILTER_URL_KEYS = {
  name: 'sn',
  projects: 'sp',
  users: 'su',
} as const;
